// Backwards-compat shim. WordPress.com is no longer a content source — all
// posts come from the local `posts` table, fully translated at write-time.
// These hooks now just pass through the SSR loader data.
import type { WpArticle, WpArticleFull } from "@/lib/posts.types";

export function useLocalizedPosts(
  initial: WpArticle[],
  _opts: { scope?: "all" | "home" } = {},
): { articles: WpArticle[]; isTranslating: boolean } {
  return { articles: initial, isTranslating: false };
}

export function useLocalizedPost(initial: WpArticleFull): {
  post: WpArticleFull;
  isTranslating: boolean;
} {
  return { post: initial, isTranslating: false };
}
